import { CmsObjectWithDefault } from '@components/Cms/types';

export type SubmitOtpFormViewCmsKey =
    | 'otpSentNumber'
    | 'otpExpiredTime'
    | 'verifyOtp'
    | 'didntRecieve'
    | 'resendOtp'
    | 'otpSentEmail';

export const SubmitOtpFormViewCmsWithDefault: CmsObjectWithDefault<SubmitOtpFormViewCmsKey> = {
    verifyOtp: {
        cmsId: 97929,
        defaultTranslation: 'Submit OTP',
    },
    otpSentNumber: {
        cmsId: 97927,
        defaultTranslation: 'An OTP has been sent to phone number {0}',
    },
    otpSentEmail: {
        cmsId: 92143,
        defaultTranslation: 'New OTP has been sent to your email',
    },
    otpExpiredTime: {
        cmsId: 97928,
        defaultTranslation: 'An OTP will expire in 10 minutes',
    },
    didntRecieve: {
        cmsId: 97930,
        defaultTranslation: "Didn't receive?",
    },
    resendOtp: {
        cmsId: 97931,
        defaultTranslation: 'Resend OTP',
    },
};
